var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7066 0.292786C10.5191 0.105315 10.2648 0 9.99959 0C9.73443 0 9.48012 0.105315 9.29259 0.292786L5.99959 3.58579L2.70659 0.292786C2.51799 0.110628 2.26539 0.00983408 2.00319 0.0121125C1.74099 0.0143909 1.49018 0.11956 1.30477 0.304968C1.11937 0.490376 1.0142 0.741188 1.01192 1.00339C1.00964 1.26558 1.11043 1.51818 1.29259 1.70679L4.58559 4.99979L1.29259 8.29279C1.19708 8.38503 1.1209 8.49538 1.06849 8.61738C1.01608 8.73939 0.988496 8.87061 0.987342 9.00339C0.986189 9.13616 1.01149 9.26784 1.06177 9.39074C1.11205 9.51364 1.18631 9.62529 1.2802 9.71918C1.37409 9.81307 1.48574 9.88733 1.60864 9.93761C1.73154 9.98789 1.86321 10.0132 1.99599 10.012C2.12877 10.0109 2.25999 9.9833 2.382 9.93089C2.504 9.87848 2.61435 9.8023 2.70659 9.70679L5.99959 6.41379L9.29259 9.70679C9.4812 9.88894 9.7338 9.98974 9.99599 9.98746C10.2582 9.98518 10.509 9.88001 10.6944 9.6946C10.8798 9.5092 10.985 9.25838 10.9873 8.99619C10.9895 8.73399 10.8888 8.48139 10.7066 8.29279L7.41359 4.99979L10.7066 1.70679C10.8941 1.51926 10.9994 1.26495 10.9994 0.999786C10.9994 0.734622 10.8941 0.480314 10.7066 0.292786Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.925dc754b217e494c84d2ff5a7472246.svg";
export { ForwardRef as ReactComponent };